import React, { useEffect } from 'react';
import { ContactSection } from '../components/ContactSection';
export function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24" data-id="element-384">
      <ContactSection data-id="element-385" />
    </div>;
}